import React, { useEffect, useState, useContext } from 'react'

import styles from './RepresentanteLegal.module.css'
import Subtitle from '../Subtitle'

import GeneralContext from '../../context/GeneralContext'

//Utiles
import * as Constantes from '../../utils/constantes'
import * as Funciones from '../../utils/funciones'

const RepresentanteLegal = ({ contratante, state, setState }) => {
    const { state: generalState } = useContext(GeneralContext)
    let user = generalState.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected || prospecto.completado)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]
    const [documentos, setDocumentos] = useState([])

    const handleChangeTexto = (event, campo) => {
        let valor = event.target.value.replace(/[^a-z A-Z À-ÿ \u00f1\u00d1]/gi, "")
        let capital = Funciones.mostrarCamelCase(valor)
        let campoAux = ''
        if (campo === 'nombres') {
            campoAux = 'nombresRL'
        } else if (campo === 'apellidoPaterno') {
            campoAux = 'apellidoPaternoRL'
        } else if (campo === 'apellidoMaterno') {
            campoAux = 'apellidoMaternoRL'
        }

        setState((state) => {
            return {
                ...state,
                contratante: {
                    ...state.contratante,
                    representanteLegal: {
                        ...state.contratante.representanteLegal,
                        [campo]: capital
                    }
                },
                campoValidado: {
                    ...state.campoValidado,
                    [campoAux]: true
                }
            }
        })
    }

    const handleChangeNumerico = (e, campo, codigo) => {
        let valor = ''
        switch (codigo) {
            case 1:
                valor = e.target.value.replace(/[^0-9 \u00f1\u00d1]/gi, "")
                break;
            case 3:
                valor = e.target.value.replace(/[^0-9A-Z]/gi, "")
                valor = valor.toUpperCase()
                break;
            case 4:
                valor = e.target.value.replace(/[^0-9 \u00f1\u00d1]/gi, "")
                break;
            default:
                console.error('No existe un Tipo de documento válido')
        }
        setState((state) => {
            return {
                ...state,
                contratante: {
                    ...state.contratante,
                    representanteLegal: {
                        ...state.contratante.representanteLegal,
                        [campo]: valor
                    }
                },
                campoValidado: {
                    ...state.campoValidado,
                    numeroDocumentoRL: true
                }
            }
        })
    }

    useEffect(() => {
        setDocumentos(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 13))
    }, [])

    const tamanioDocumento = (codigo) => {
        if (codigo !== null && codigo !== undefined) {
            return Constantes['CANTIDAD_DIGITOS_TIPO_DOCUMENTO_' + codigo]
        } else {
            return '0'
        }
    }

    //Modo lectura
    let Deshabilitar = (complete) => {
        complete = cotizacion.edicionInhabilitada
        if (complete === true && complete !== undefined) {
            return true
        } else {
            return false
        }
    }

    return (
        <div className={styles['areadatosprospecto']}>
            <Subtitle
                sname="Representante legal"
                smostrar="false"
            />
            <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                <div className={styles['area50']}>
                    <label>Nombres&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <input type='text'
                        style={{ paddingLeft: '2%' }}
                        className={!state.campoValidado.nombresRL ? styles['logerror'] : null}
                        value={contratante.representanteLegal !== null && contratante.representanteLegal !== undefined
                            ? contratante.representanteLegal.nombres || '' : ''}
                        onChange={(e) => handleChangeTexto(e, 'nombres')}
                        disabled={Deshabilitar() !== true ? false : true}
                        maxLength={40}
                    />
                    {!state.campoValidado.nombresRL &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_NOMBRES}</span>
                    }
                </div>
                <div className={styles['area25']}>
                    <label>Apellido Paterno&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <input type='text'
                        style={{ paddingLeft: '3.5%' }}
                        className={!state.campoValidado.apellidoPaternoRL ? styles['logerror'] : null}
                        value={contratante.representanteLegal !== null && contratante.representanteLegal !== undefined
                            ? contratante.representanteLegal.apellidoPaterno || '' : ''}
                        onChange={(e) => handleChangeTexto(e, 'apellidoPaterno')}
                        disabled={Deshabilitar() !== true ? false : true}
                        maxLength={30}
                    />
                    {!state.campoValidado.apellidoPaternoRL &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_APE_PATERNO}</span>
                    }
                </div>
                <div className={styles['area25']}>
                    <label>Apellido Materno&nbsp;{(contratante.representanteLegal !== undefined && contratante.representanteLegal.tipoDocumento
                        && contratante.representanteLegal.tipoDocumento.codigo) !== 3 ?
                        Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS : null}</label>
                    <input type='text'
                        className={!state.campoValidado.apellidoMaternoRL ? styles['logerror'] : null}
                        value={contratante.representanteLegal !== null && contratante.representanteLegal !== undefined
                            ? contratante.representanteLegal.apellidoMaterno || '' : ''}
                        onChange={(e) => handleChangeTexto(e, 'apellidoMaterno')}
                        disabled={Deshabilitar() !== true ? false : true}
                        maxLength={30}
                    />
                    {!state.campoValidado.apellidoMaternoRL &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_APE_MATERNO}</span>
                    }
                </div>
            </div>
            <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                <div className={styles['area25']}>
                    <label>Tipo Doc.&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <select
                        value={contratante.representanteLegal !== null && contratante.representanteLegal !== undefined
                            && contratante.representanteLegal.tipoDocumento ?
                            contratante.representanteLegal.tipoDocumento.codigo : ''}
                        disabled={true}
                        onChange={(e) => handleChangeTexto(e, 'apellidoMaterno')}
                    >
                        <option value={0}>Seleccione</option>
                        {documentos && documentos.length > 0 && documentos.filter(doc => { return doc.id !== 2 && doc.id !== 5 }).map(documento => (
                            <option key={documento.id} value={documento.id}>
                                {documento.valor}
                            </option>
                        ))}
                    </select>
                </div>
                <div className={styles['area25']}>
                    <label>Nro. de Doc. Identidad&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <input type='text'
                        className={!state.campoValidado.numeroDocumentoRL ? styles['logerror'] : null}
                        value={contratante.representanteLegal ? contratante.representanteLegal.numeroDocumento : ''}
                        maxLength={tamanioDocumento(contratante.representanteLegal !== undefined && contratante.representanteLegal.tipoDocumento
                            && contratante.representanteLegal.tipoDocumento.codigo)}
                        onChange={(e) => handleChangeNumerico(e, 'numeroDocumento', contratante.representanteLegal.tipoDocumento.codigo)}
                        disabled={Deshabilitar() !== true ? false : true}
                    />
                    {!state.campoValidado.numeroDocumentoRL &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_NUM_DOCUMENTO}</span>
                    }
                </div>
                <div className={styles['area50']}></div>
            </div>
        </div>
    )
}

export default RepresentanteLegal